import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterTaxesState } from "./type";

const INITIAL_STATE: FilterTaxesState = {
  filters: {
    taxType: "",
  },
};

const filterTaxesSlice = createSlice({
  name: "filterTaxes",
  initialState: INITIAL_STATE,
  reducers: {
    setTaxType(state, action: PayloadAction<string>) {
      state.filters.taxType = action.payload;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
  },
});

export const { setTaxType, resetFilters } = filterTaxesSlice.actions;
export default filterTaxesSlice.reducer;
